<div class="support-wrapper">
  <div class="glow green"></div>
  <div class="glow purple"></div>
  <h1>Support & Disputes</h1>
  <p class="support-description">
    Need help with a refund or have a dispute? We're here to help you resolve any issues
    with your gaming experience.
  </p>

  <div class="support-form">
    <form [formGroup]="supportForm" (ngSubmit)="submitRequest()">
      <h2>Contact Support</h2>

      <!-- Subject -->
      <div class="form-group">
        <label for="subject">Subject</label>
        <input
          id="subject"
          formControlName="subject"
          type="text"
          placeholder="Subject"
          [ngClass]="{ 'invalid': isFieldInvalid('subject') }"
        />
        <div class="error-message" *ngIf="isFieldInvalid('subject')">
          Subject is required and must be at least 5 characters
        </div>
      </div>

      <!-- Description -->
      <div class="form-group">
        <label for="description">Description</label>
        <textarea
          id="description"
          formControlName="description"
          placeholder="Describe your issue"
          [ngClass]="{ 'invalid': isFieldInvalid('description') }"
        ></textarea>
        <div class="error-message" *ngIf="isFieldInvalid('description')">
          Description is required and must be at least 5 characters
        </div>
      </div>

      <div class="btn-wrapper">
        <button
          class="submit-btn btn"
          [ngClass]="{
    'disabled-button': supportForm.controls['description'].invalid || supportForm.controls['subject'].invalid,
    'loading': isLoading
  }"
          type="submit"
          [disabled]="supportForm.invalid || isLoading"
        >
          <span *ngIf="!isLoading">Submit Request</span>
          <span *ngIf="isLoading" class="spinner"></span>
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Success modal -->
<app-modal
  class="submit-btn-modal"
  [isOpen]="isSubmitted"
  [icon]="'assets/images/info.png'"
  [title]="'Request submitted!'"
  [text]="'Check your email. Our team will get back to you soon.'"
  [primaryBtnText]="'Home Page'"
  (primaryClick)="goHome()"
  (close)="isSubmitted = false">
</app-modal>

<!-- Error modal -->
<app-modal
  class="submit-btn-modal error"
  [isOpen]="isError"
  [icon]="'assets/images/warning.png'"
  [title]="'Something went wrong!'"
  [text]="'Please try again later or contact us via email.'"
  [primaryBtnText]="'Try Again'"
  [type]="'error'"
  (primaryClick)="isError = false"
  (close)="isError = false">
</app-modal>
